module.exports = __webpack_public_path__ + "img/zerocarbon1.0ea33b30.png";